import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid, makeStyles, Typography } from '@material-ui/core';

import { CustomSVG, IUploader, Uploader, UploadInput } from 'components';
import { useClient, useNotify } from 'hooks';
import { S3ObjectInput, useCreateClientStickerMutation } from 'api';
import { createClientStickerResponse } from 'apollo/responses';

import { STICKER_SIZE } from './constants';

const useStyles = makeStyles(theme => ({
  addStickerIcon: {
    marginBottom: theme.spacing(1),
  },
}));

const StickerUpload: FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const client = useClient();
  const { id } = client;
  const notify = useNotify();

  const [createClientStickerMutation] = useCreateClientStickerMutation({
    onError: notify.mutationError,
    onCompleted: notifySuccess,
  });

  function notifySuccess() {
    const message = t('components:savedSuccessfully');
    notify.info({ message });
  }

  function handleSave(image: S3ObjectInput) {
    const data = { client_id: id, image };
    const sticker = {
      bucket: image.bucket,
      height: STICKER_SIZE,
      width: STICKER_SIZE,
      key: 'loaders/sticker.gif?format=auto',
      region: image.region,
    };

    return createClientStickerMutation({
      variables: { data },
      optimisticResponse: createClientStickerResponse({ client, sticker }),
    });
  }

  return (
    <Fragment>
      <Uploader onSave={handleSave} disableCropper>
        {(uploaderProps: IUploader) => (
          <UploadInput onUpload={uploaderProps.onUpload}>
            <Button component="span">
              <Grid container direction="column" alignItems="center" justify="center">
                <CustomSVG
                  className={classes.addStickerIcon}
                  name="sticker"
                  viewBox="0 0 40 40"
                  size={40}
                />
                <Typography>{t('admin:shareStickersAdd')}</Typography>
              </Grid>
            </Button>
          </UploadInput>
        )}
      </Uploader>
    </Fragment>
  );
};

export default StickerUpload;
